module.exports = __webpack_public_path__ + "static/img/university-logo_V0.1-01.b54d58d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/genestesting/university-logo_V0.1-01.png
// module id = xjq6
// module chunks = 0